<template>
  <div class="flex items-center">
    <div class="rounded-lg border bg-background size-[100px] p-4 flex items-center justify-center mr-2">
      <img
        v-if="isImage(fileType)"
        width="64"
        height="64"
        class="rounded-full size-16"
        :src="fileUrl"
        alt="file preview"
        aria-hidden="true"
      >
      <img
        v-else
        width="64"
        src="@/assets/images/pdf-icon.png"
        alt="pdf icon"
      >
    </div>

    <div>
      <p
        class="text-sm mb-1 ps-2 line-clamp-1"
        :title="fileName"
      >
        {{ fileName }}
      </p>
      <Button
        size="icon"
        variant="ghost"
        type="button"
        :disabled="disabled"
        aria-label="Replace file"
        @click="$emit('replace')"
      >
        <Pencil class="size-4" />
      </Button>
      <Button
        size="icon"
        variant="ghost"
        type="button"
        :disabled="disabled"
        aria-label="Remove file"
        @click="$emit('remove')"
      >
        <Trash class="size-4" />
      </Button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, type PropType } from 'vue'
import { Pencil, Trash } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { isImage } from '@/lib/filters.js'
import { storedFileName, storedFileUrl } from '@/lib/files.js'

const props = defineProps({
  file: {
    type: Object as PropType<any>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['remove', 'replace'])

const fileName = computed(() => storedFileName(props.file))
const fileUrl = computed(() => storedFileUrl(props.file))
const fileType = computed(() => props.file?.file_type || props.file?.mime_type || '')
</script>
